import { Reducer } from 'redux';
import {
  CONTENT_LIB_SET_CATEGORIES_ACTION,
  CONTENT_LIB_SET_GROUP_COPY_CONFIRM_ACTION,
  CONTENT_LIB_SET_GROUPS_SEARCH_RESULT_ACTION,
  CONTENT_LIB_SET_LANGS_ACTION,
  CONTENT_LIB_SET_LOCKED_MODE_ACTION,
  CONTENT_LIB_SET_OPEN_CATEGORIES_ACTION,
  CONTENT_LIB_SET_SEARCH_FILTER_ACTION,
  CONTENT_LIB_SET_SELECTED_CATEGORY_ACTION,
  CONTENT_LIB_SET_SELECTED_GROUP_ACTION,
  CONTENT_LIB_SET_VIDEO_COPY_CONFIRM_ACTION,
  CONTENT_LIB_SET_VIDEO_POPUP_ACTION,
  CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_ACTION,
  CONTENT_LIB_SET_VIEW_MODE_ACTION,
  CONTENT_LIB_SHOW_FIRST_GROUP_CREATED_MESSAGE_ACTION,
  CONTENT_LIB_UPDATE_VIDEO_ACTION,
  EContentLibViewMode,
  IContentLibState,
  IContentLibUpdateVideoAction,
  TContentLibActions
} from './types';
import { EUserLevel } from '../general/types';

const initialState: IContentLibState = {
  searchFilter: {
    targetLangCode: '',
    nativeLangCode: '',
    text: '',
    level: EUserLevel.UNKNOWN
  },
  groupsSearchResult: {
    groups: null,
    loading: false
  },
  videosSearchResult: null,
  videoPopup: {
    groupId: 0,
    videoId: 0
  },
  viewMode: EContentLibViewMode.VIDEO_LIST,
  selectedGroupId: 0,
  selectedCategoryId: 0,
  copyGroupConfirm: {
    show: false
  },
  copyVideoConfirm: {
    show: false
  },
  langs: {
    nativeLangs: [],
    targetLangs: []
  },
  lockedMode: false,
  categories: [],
  showFirstGroupCreatedMessage: 0
};

export const contentLibReducer: Reducer<IContentLibState, TContentLibActions> = (
  state = initialState,
  action
) => {

  switch (action.type) {
    case CONTENT_LIB_SET_GROUPS_SEARCH_RESULT_ACTION:
      return {
        ...state,
        groupsSearchResult: {...state.groupsSearchResult, ...action.groupsSearchResult}
      };
    case CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_ACTION:
      return {
        ...state,
        videosSearchResult: action.videosSearchResult,
      };
    case CONTENT_LIB_SET_SEARCH_FILTER_ACTION:
      return {
        ...state,
        searchFilter: {...state.searchFilter, ...action.searchFilter}
      };
    case CONTENT_LIB_SET_VIEW_MODE_ACTION:
      const group = action.viewMode === EContentLibViewMode.GROUP_VIDEO_LIST
        ? {}
        : {
          selectedGroupId : null,
        };
      return {
        ...state,
        viewMode: action.viewMode,
        ...group,
      };
    case CONTENT_LIB_SET_VIDEO_POPUP_ACTION:
      return {
        ...state,
        videoPopup: {...state.videoPopup, ...action.videoPopup}
      }
    case CONTENT_LIB_SET_VIDEO_COPY_CONFIRM_ACTION:
      return {
        ...state,
        copyVideoConfirm:  {...state.copyVideoConfirm, ...action.copyVideoConfirm}
      }
    case CONTENT_LIB_SET_GROUP_COPY_CONFIRM_ACTION:
      return {
        ...state,
        copyGroupConfirm:  {...state.copyGroupConfirm, ...action.copyGroupConfirm}
      }
    case CONTENT_LIB_SET_SELECTED_GROUP_ACTION:
      return {
        ...state,
        selectedGroupId: action.selectedGroupId
      };
    case CONTENT_LIB_SET_SELECTED_CATEGORY_ACTION:
      return {
        ...state,
        selectedCategoryId: action.selectedCategoryId
      };
    case CONTENT_LIB_SET_LANGS_ACTION:
      return {
        ...state,
        langs: {...action.langs}
      };
    case CONTENT_LIB_SET_LOCKED_MODE_ACTION:
      return {
        ...state,
        lockedMode: action.lockedMode
      };
    case CONTENT_LIB_SET_CATEGORIES_ACTION:
      return {
        ...state,
        categories: [...action.categories]
      };
    case CONTENT_LIB_SET_OPEN_CATEGORIES_ACTION:
      return {
        ...state,
        isOpenCategories: action.isOpenCategories
      };
    case CONTENT_LIB_UPDATE_VIDEO_ACTION:
      return updateVideo(state, action);
      case CONTENT_LIB_SHOW_FIRST_GROUP_CREATED_MESSAGE_ACTION:
        return {
          ...state,
          showFirstGroupCreatedMessage: action.showFirstGroupIdCreatedMessage
        };

    default:
      return state;
  }
};

const updateVideo = (state: IContentLibState, action: IContentLibUpdateVideoAction): IContentLibState => {
  const {id, updateData} = action;
  const result = {...state};
  if (result.videosSearchResult?.length > 0) {
    const index = result.videosSearchResult.findIndex(v => v.id === id);
    if (index >= 0) {
      result.videosSearchResult[index] = {...result.videosSearchResult[index], ...updateData}
    }
  }
  return result;
}